G.Input = G.Input || {};
G.Input.createCustomInputClickHandler = function createCustomInputClickHandler() {

  // imports
  var EventType = G.Input.EventType;
  var StateMachine = G.StateMachine;

  //

  var signals = {
    down:   new Phaser.Signal(),
    click:  new Phaser.Signal(),
    cancel: new Phaser.Signal()
  };

  var customInput = {
    // custom input handler interface
    handleEventShared:    handleEventShared,
    handleEventExclusive: handleEventExclusive,
    cancelEvent:          cancelEvent,

    // custom
    downSignal:   signals.down,
    clickSignal:  signals.click,
    cancelSignal: signals.cancel
  };


  var State = {
    Idle:    "idle",
    Down:    "down",
    Cancel:  "cancel",
    Confirm: "confirm"
  };
  var stateMachine = doCreateStateMachine();

  return customInput;

  function doCreateStateMachine() {
    var transitions = {}
    transitions[State.Idle]    = [State.Down];
    transitions[State.Down]    = [State.Cancel, State.Confirm];
    transitions[State.Cancel]  = [State.Idle];
    transitions[State.Confirm] = [State.Idle];

    var stateMachine = new StateMachine(State.Idle, transitions);

    stateMachine.transitionSignal.add(function(newState, oldState) {
      switch (newState) {
        case State.Idle: break;

        case State.Down:
          signals.down.dispatch();
        break;

        case State.Cancel:
          stateMachine.transit(State.Idle);
          signals.cancel.dispatch();
        break;

        case State.Confirm:
          stateMachine.transit(State.Idle);
          signals.click.dispatch();
        break;
      }
    });

    return stateMachine;
  }

  function handleEventShared(eventType, pointer) {
    if (eventType === EventType.InputDown) {
      return stateMachine.transitIfPossible(State.Down);
    }
    if (
      eventType === EventType.DragStart ||
      eventType === EventType.InputOut
    ) {
      stateMachine.transitIfPossible(State.Cancel);
      return false;
    }

    return (
      eventType === EventType.InputUp &&
      stateMachine.canTransitTo(State.Confirm)
    );
  }

  function handleEventExclusive(eventType, pointer) {
    if (
      eventType === EventType.InputUp &&
      stateMachine.canTransitTo(State.Confirm)
    ) {
      stateMachine.transit(State.Confirm);
      return true;
    }
    return false;
  }

  function cancelEvent(eventType) {
    stateMachine.transitIfPossible(State.Cancel);
  }
};
